// @ts-nocheck
import React from "react";
import {CookiesProvider} from "react-cookie";

import {Api} from "./Api";
import {AuthProvider} from "./AuthContext";
import {PlayMakersConfig, PlayMakersProviderProps} from "./types";

const PlayMakersConfigDefault = {
  API_BASEURL: "https://api.playmakers.co",
  API_CACHE_EXPIRATION: 2000,
  BARISTA_BASEURL: "https://barista.playmakers.co",
  BARISTA_VERSION: "latest",
  COGNITO: {
    CLIENT_ID: "1bkjbgkktdujdv23r62eue2elo",
    DOMAIN: "cognito.playmakers.co",
    POOL_ID: "eu-north-1_qMIFaOOnN",
    REDIRECT_SIGNIN: [`${window.location.origin}/handle-from-federated`],
    REDIRECT_SIGNOUT: [`${window.location.origin}/handle-signout`],
    REGION: "eu-north-1"
  },
  IDSERVER_BASEURL: "https://id.playmakers.co",
  // How often in ms do we poll for notifications
  NOTIFICATIONS_POLL_PERIOD: 30000,
  PROJECT_ID: undefined,
  // How often in ms we poll the submission status for `pending...` to clear
  SUBMISSION_UPLOAD_POLL_PERIOD: 2000,
  // How long MH will wait in ms before displaying timeout message
  // Note if the submission takes longer it is not cancelled, it will still be processed
  SUBMISSION_UPLOAD_TIMEOUT: 90000,
  TWITTER: {
    CALLBACK_URL: `${window.location.origin}/handle-from-twitter`
  },
  UPLOADS_BASEURL: "https://file.playmakers.co"
};

const PlayMakersContext = React.createContext<PlayMakersConfig>(PlayMakersConfigDefault);
export const usePlayMakersConfig = (): PlayMakersConfig => React.useContext(PlayMakersContext);

export const PlayMakersProvider = ({children, ...props}: PlayMakersProviderProps) => {
  const value = {...PlayMakersConfigDefault, ...props};
  value.COGNITO = {...PlayMakersConfigDefault.COGNITO, ...props.COGNITO};

  // TODO Might need to add a way to change PROJECT_ID on the fly, maybe ?

  return <PlayMakersContext.Provider value={value}>
    <CookiesProvider defaultSetOptions={{path: "/"}}>
      <ApiProvider>
        <AuthProvider>
          {children}
        </AuthProvider>
      </ApiProvider>
    </CookiesProvider>
  </PlayMakersContext.Provider>;
};


const ApiContext = React.createContext<Api>({});
export const useApi = () => React.useContext(ApiContext);

const ApiProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const config = usePlayMakersConfig();
  const api = new Api(config);

  const value = {};
  for(const method of api.exports) {
    value[method] = api[method];
    value[method].methodName = method;
  }

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};
